import React from 'react'
import Logo from '../../assets/logo.png'
import Kapsul from '../../assets/kapsul2.png'
import BgMobile from '../../assets/bg_mobile.png'

type Props = {
  onNext: () => void
}

const WelcomeScreen: React.FC<Props> = ({ onNext }) => {
  return (
    <div
      className="fixed inset-0 w-screen h-screen flex flex-col overflow-hidden"
      style={{
        background: '#181B1E',
        backgroundImage: `url(${BgMobile})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-[#DFFF00]/10 rounded-full blur-[100px]" />

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 relative z-10">
        {/* Logo */}
        <div className="mb-12">
          <img src={Logo} alt="TextToNext" className="h-[25px]" />
        </div>

        {/* Kapsul Image */}
        <div className="mb-12">
          <img
            src={Kapsul}
            alt="Kapsül"
            className="w-auto h-auto max-w-[200px]"
          />
        </div>

        {/* Title */}
        <h2
          className="text-white text-center mb-3"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 400,
            fontSize: '23px',
            lineHeight: '28px',
            maxWidth: '302px',
          }}
        >
          Zaman Kapsülü'ne Hoş Geldin.
        </h2>

        <br />
        <p
          className="text-white text-center"
          style={{
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '20px',
            maxWidth: '275px',
            marginBottom: '48px',
          }}
        >
          Bu büyük bir hikayenin başlangıcı olabilir.
        </p>

        {/* Button */}
        <button
          onClick={onNext}
          className="text-black rounded-2xl transition-all active:scale-[0.98]"
          style={{
            background: '#D6FF00',
            width: '340.25px',
            height: '45.12px',
            maxWidth: '90vw',
            fontFamily: 'MorebiRounded, sans-serif',
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          Başla
        </button>
      </div>
    </div>
  )
}

export default WelcomeScreen
